module.exports = __webpack_public_path__ + "static/media/AR-products-three@2x.a6012fad.png";